import React from 'react';
import { Navigate } from 'react-router-dom';
import { Card, Typography, Tabs, Spin } from 'antd';

import { usePermissaoRecurso } from '../../hooks/usePermissoes';
import PeriodosAdminPainel from './PeriodosAdminPainel';
import CriteriosAdminPainel from './CriteriosAdminPainel';

const { Title, Text } = Typography;

// Página principal administrativa do módulo de Avaliações de Alunos
// (Fase 7). Estrutura de abas (Períodos/Critérios) em vez de rotas
// separadas -- são visões irmãs do mesmo módulo, sem hierarquia entre si
// (mesmo princípio de simplicidade já usado nas abas da tela de detalhe
// do período). Recurso RBAC "avaliacoes_gestao" -- exclusivo de ADMIN
// (migration 079); backend continua sendo a autoridade real, esta
// checagem só decide o que É MOSTRADO.
const AvaliacoesAdmin = () => {
  const { loading, isAdmin, podeVisualizar } = usePermissaoRecurso('avaliacoes_gestao');

  if (loading) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', padding: 48 }}>
        <Spin size="large" tip="Validando permissões..." />
      </div>
    );
  }

  if (!isAdmin && !podeVisualizar) {
    return <Navigate to="/acesso-negado" replace />;
  }

  return (
    <Card>
      <Title level={3} style={{ marginBottom: 4 }}>
        Avaliações
      </Title>
      <Text type="secondary">Gestão de períodos e critérios de avaliação de alunos.</Text>

      <Tabs
        style={{ marginTop: 24 }}
        defaultActiveKey="periodos"
        items={[
          { key: 'periodos', label: 'Períodos', children: <PeriodosAdminPainel /> },
          { key: 'criterios', label: 'Critérios', children: <CriteriosAdminPainel /> },
        ]}
      />
    </Card>
  );
};

export default AvaliacoesAdmin;
